module.exports = __webpack_public_path__ + "media/images/social/linkedin-a84a4b6bbe91eccccf9b1dc3c40d8bb9.png";